const CreatePostForm = () => {
  return (
    <div className="rounded-3xl bg-light box-border flex flex-col py-16 px-8 items-center justify-start gap-[64px] min-w-[400px] max-w-[600px] text-left text-28xl text-dark font-footnote border-b-[4px] border-solid border-lavender lg:self-stretch lg:w-auto lg:min-w-[400px] lg:max-w-[500px] sm:w-auto sm:[align-self:unset] sm:pl-8 sm:pr-8 sm:box-border sm:max-w-0">
      <b className="self-stretch relative tracking-[-0.02em] leading-[40px] text-center">
        Create Post
      </b>
      <div className="self-stretch flex flex-col items-center justify-start gap-[16px] text-base">
        <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
          <label
            className="cursor-pointer self-stretch relative font-bold"
            htmlFor="Label"
          >
            Title*
          </label>
          <input
            className="font-footnote text-base bg-gray-100 self-stretch rounded-21xl flex flex-row p-4 items-center justify-center border-[1px] border-solid border-darkslategray-200"
            type="text"
            placeholder="Eg. Sushi Buffet with Private Seating"
            maxLength={80}
            required
            id="Label"
          />
        </div>
        <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
          <label
            className="cursor-pointer self-stretch relative font-bold"
            htmlFor="Label"
          >
            Link*
          </label>
          <input
            className="font-footnote text-base bg-gray-100 self-stretch rounded-21xl flex flex-row p-4 items-center justify-center border-[1px] border-solid border-darkslategray-200"
            type="text"
            placeholder="www.helpfulsite.com"
            required
            id="Label"
          />
        </div>
        <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
          <b className="self-stretch relative">Type*</b>
          <div className="self-stretch rounded-21xl bg-gray-300 flex flex-row p-4 items-center justify-start gap-[10px] border-[1px] border-solid border-darkslategray-200">
            <div className="flex-1 relative">Select Post Type</div>
            <img
              className="relative rounded-sm w-4 h-[12.39px]"
              alt=""
              src="/vector-4121.svg"
            />
          </div>
        </div>
        <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
          <label
            className="cursor-pointer self-stretch relative font-bold"
            htmlFor="Label"
          >
            Address*
          </label>
          <input
            className="font-footnote text-base bg-gray-100 self-stretch rounded-21xl flex flex-row p-4 items-center justify-center border-[1px] border-solid border-darkslategray-200"
            type="text"
            placeholder="123 Place St, City, USA, 12345"
            required
            id="Label"
          />
        </div>
        <div className="self-stretch hidden flex-col items-center justify-start gap-[8px]">
          <label
            className="cursor-pointer self-stretch relative font-bold"
            htmlFor="Label"
          >
            Price*
          </label>
          <input
            className="font-footnote text-base bg-gray-100 self-stretch rounded-21xl flex flex-row p-4 items-center justify-center border-[1px] border-solid border-darkslategray-200"
            type="text"
            placeholder="123 Place St, City, USA, 12345"
            required
            id="Label"
          />
        </div>
        <div className="self-stretch hidden flex-row items-start justify-center gap-[16px]">
          <div className="flex-1 flex flex-col items-center justify-start gap-[8px]">
            <label
              className="cursor-pointer self-stretch relative font-bold"
              htmlFor="Label"
            >
              Date*
            </label>
            <input
              className="font-footnote text-base bg-gray-100 self-stretch rounded-21xl flex flex-row p-4 items-center justify-center border-[1px] border-solid border-darkslategray-200"
              type="text"
              placeholder="www.helpfulsite.com"
              required
              id="Label"
            />
          </div>
          <div className="flex-1 flex flex-col items-center justify-start gap-[8px]">
            <label
              className="cursor-pointer self-stretch relative font-bold"
              htmlFor="Label"
            >
              Time*
            </label>
            <input
              className="font-footnote text-base bg-gray-100 self-stretch rounded-21xl flex flex-row p-4 items-center justify-center border-[1px] border-solid border-darkslategray-200"
              type="text"
              placeholder="www.helpfulsite.com"
              required
              id="Label"
            />
          </div>
        </div>
        <div className="self-stretch flex flex-col items-center justify-start gap-[8px]">
          <label
            className="cursor-pointer self-stretch relative font-bold"
            htmlFor="Label"
          >
            Description*
          </label>
          <textarea
            className="bg-gray-100 font-footnote text-base self-stretch rounded-21xl flex flex-row p-4 items-center justify-center border-[1px] border-solid border-darkslategray-200"
            placeholder="Talk about why it’s great in 160 Characters :)"
            required
            maxLength={160}
          />
        </div>
        <div className="self-stretch flex flex-col items-center justify-start gap-[16px]">
          <b className="self-stretch relative">Sensitivity Tags</b>
          <div className="self-stretch flex flex-row items-start justify-start gap-[32px]">
            <div className="flex flex-col items-start justify-start gap-[16px]">
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Taste</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Staff</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Wait Time</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Crowds</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Orderliness</div>
              </div>
            </div>
            <div className="flex flex-col items-start justify-start gap-[16px]">
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Noise</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Smells</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Lighting</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Visual</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Motor Skills</div>
              </div>
            </div>
            <div className="flex flex-col items-start justify-start gap-[16px]">
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Balance</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Lifestyle</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Therepeutic</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Entertainment</div>
              </div>
              <div className="flex flex-row items-center justify-start gap-[8px]">
                <input
                  className="cursor-pointer relative bg-gainsboro w-4 h-4"
                  type="checkbox"
                  id="Checkbox"
                />
                <div className="relative">Body</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rounded-31xl bg-gold w-[479px] flex flex-row py-[22px] px-8 box-border items-center justify-center text-5xl hover:bg-goldenrod-100 active:bg-darkkhaki">
        <b className="relative">Create Post</b>
      </div>
    </div>
  );
};

export default CreatePostForm;
